import { Guid } from 'guid-typescript';
import { ScheduledRetrievalGridDetails } from '../Types/ScheduledRetrieval.types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../../app/store';
import { getScheduledRetrievalGridData } from '../../api/ScheduledRetrievals/ScheduledRetrievals.api';
import { showErrorSnackbar } from '../../component/snackbar/Snackbar.slice';
import { Messages } from '../../Constants/Messages';

interface State {
    allScheduledRetrievalGridData: ScheduledRetrievalGridDetails[];
    hasNoValue: boolean;
}

const initialState: State = {
    allScheduledRetrievalGridData: [] as ScheduledRetrievalGridDetails[],
    hasNoValue: false,
}

export const loadScheduledRetrievalsData = createAsyncThunk<
    void,
    void,
    {
        dispatch: AppDispatch;
        state: RootState;
    }
>('scheduledRetrievals', async (_: void, thunkAPI) => {
    let errorState = false;
    let gridData = [] as ScheduledRetrievalGridDetails[];
    const response = async () => {
        return await getScheduledRetrievalGridData();
    };
    return Promise.all([
        response()
    ]).then(function (values :any) {
        if (values.length > 0 && values[0]) {
            if (JSON.parse(values[0].Data).length > 0) {
                thunkAPI.dispatch(setHasNoValue(false));
            }
            else {
                thunkAPI.dispatch(setHasNoValue(true));
            }
            gridData = JSON.parse(values[0].Data.toString()) as ScheduledRetrievalGridDetails[];
        } else {
            thunkAPI.dispatch(setHasNoValue(true));
            if (!errorState) {
                errorState = true;
            }
        }
        if (errorState) {
            showErrorSnackbar(thunkAPI.dispatch, Messages.EXCEPTION_FOR_FETCH);
        } else {
            thunkAPI.dispatch(setAllScheduledRetrievalGridData(gridData));
        }
    });
});

const scheduledRetrievalSlice = createSlice({
    name: 'scheduledRetrievals',
    initialState,
    reducers: {
        setAllScheduledRetrievalGridData(state, action: PayloadAction<ScheduledRetrievalGridDetails[]>): any {
            return { ...state, allScheduledRetrievalGridData: action.payload };
        },
        setHasNoValue(state, action: PayloadAction<boolean>): any {
            return { ...state, hasNoValue: action.payload };
        }
    },
});

export const { setAllScheduledRetrievalGridData, setHasNoValue } = scheduledRetrievalSlice.actions;

export default scheduledRetrievalSlice.reducer;